package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestampToHHMM
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.itinerary.ui.edit_itinerary.*
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.datetime.LocalTime

@Composable
fun ItineraryServicesList(
    state: EditItineraryState,
    onEvent: (EditItineraryEvent) -> Unit,
    onNavigation: (EditItineraryNavigation) -> Unit = {},
    confirmed: Boolean = true,
) {
    val scrollState = rememberScrollState()

    val groupedServices = remember(
        state.notConfirmedServices,
        state.getAllItineraryService.data.orEmpty(),
        confirmed,
    ) {
        if (confirmed)
            state.notConfirmedServices
                .sortedWith(
                    compareBy { it.startDate },
                ).groupBy { it.startDate }
        else
            state.getAllItineraryService.data
                .orEmpty()
                .sortedWith(
                    compareBy { it.startDate },
                ).groupBy { it.startDate }
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(24.dp))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = 16.dp,
                horizontal = 20.dp,
            ),
    ) {
        if (confirmed) {
            Text(
                text = state.servicesToConfirmTitle,
                style = MaterialTheme.esTypography.h4SemiBold20.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
            )
            Spacer(modifier = Modifier.height(3.spacing))
        }

        Column(
            verticalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier
                .fillMaxHeight()
                .verticalScroll(scrollState),
        ) {
            groupedServices.forEach { (date, dayItineraryServicesList) ->
                key("header-$date") {
                    ItineraryServicesGroupDateHeader(
                        date = date,
                        modifier = Modifier
                            .align(Alignment.Start)
                            .padding(EsConstants.SectionHorizontalPadding),
                    )
                }

                dayItineraryServicesList
                    .sortedBy {
                        it.startTime?.let { time ->
                            LocalTime.parse(formatTimestampToHHMM(time))
                        }
                    }.forEach { itineraryService ->
                        val category = state.rememberCategory(itineraryService.service.category)

                        ItineraryServiceCard(
                            itineraryService = itineraryService,
                            service = itineraryService.service,
                            category = category ?: CategoryModel.empty,
                            onEvent = onEvent,
                            onNavigation = onNavigation,
                            confirmed = confirmed,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
            }
        }
    }
}